import { Injectable, inject } from '@angular/core';
import { WIRELESS_ROUTE } from '@rci/self-serve-fido/app.constant';
import { BreadcrumbsService } from '../core/breadcrumbs/breadcrumbs.service';
import { changeVoicemailBreadcrumbConfig } from './change-voicemail-breadcrumb.config';

@Injectable()
export class ChangeVoicemailAppConfigService {
  private readonly breadcrumbService = inject(BreadcrumbsService);

  constructor() {
    this.breadcrumbService.addBreadcrumbData(changeVoicemailBreadcrumbConfig);
  }

  get fallbackRoute() {
    return `/${WIRELESS_ROUTE}`;
  }

  readonly faqURL = '/support/mobility/postpaid-voice-messaging';
}
